import { Box, Button, Typography } from '@material-ui/core'
import { AddIcon } from 'assets/icons/AddIcon'
import { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { TipoPrograma } from 'store/modules/EscolasTypes';
import { HelpButton } from 'components/HelpButton';
import './index.scss'
import { useHabilitaCampoPrograma } from '../../hooks/useDisablePrograma';

import { useModalPeriodoPrograma } from '../../hooks/useModalProgramas';
interface BotaoCadastrarPeriodoProps {
    tipoPrograma: TipoPrograma;
    periodoAno?: string;
    onRefresh: () => void;
}

export const BotaoCadastrarPeriodo = ({ tipoPrograma, onRefresh }: BotaoCadastrarPeriodoProps): JSX.Element => {
    const { id, periodo, idPeriodo } = useParams() as { id: string, periodo: string, idPeriodo: string };
    const { classeCondicional, isDesabilitado } = useHabilitaCampoPrograma(tipoPrograma);
    const { openModalFormDados } = useModalPeriodoPrograma();

    const handleClick = () => {
        openModalFormDados({
            key: "cadastrar",
            tipoPrograma,
            id,
            periodo,
            idPeriodo,
            onRefresh,
        });
    };

    return (
        <Fragment>
            <Box className='BotaoCadastrarPeriodo_container-title'>
                <Typography className={`${classeCondicional} BotaoCadastrarPeriodo_label--big`}>
                    Histórico anual do programa
                    <HelpButton
                        text={'Os dados inseridos abaixo são referentes aos colaboradores(as), professores(as) e alunos(as) que participaram do programa na escola'}
                        className='BotaoCadastrarPeriodo_helpButton'
                    />
                </Typography>
                <Typography className={`${classeCondicional} BotaoCadastrarPeriodo_label--small`}>
                    Cadastre e edite as informações sobre o programa educacional:</Typography>
            </Box>

            <Box className='BotaoCadastrarPeriodo_container-button'>
                <Button
                    disabled={isDesabilitado}
                    className='button_add'
                    endIcon={<AddIcon />}
                    onClick={() => handleClick()}
                    variant='contained'
                >
                    Cadastrar Dados
                </Button>
            </Box>
        </Fragment>
    )
}
